
import { defineComponent, watch, ref } from "vue";
import runEvn from "@/modular/runEvn/RunEvn";
import { getActivityDetail, postSignUp, postCancel } from "@/api/NeighborAppointmentApi";

import { useRoute } from "vue-router";
import { Toast as toast } from 'vant';

import { getTenanCnf } from '@/modular/TenantCnf/main';
import { updateShareData } from "@/modular/Weixinh5";


const fileBaseUrl = runEvn().fileBaseUrl;

export default defineComponent({
  setup(props) {
    const route = useRoute();
    // 初始化
    const data = ref({
      id: "",
      content: "",
      title: "",
      headUrl: "",
      userName: "",
      createTimeStamp: new Date(1666007599403),
      watchCount: 0,
      LoveHelpPublishType: 0,
      contactUser: "",
      phone: "",
      targetAddress: "",
      helpStatus: 0,
      isMy: false,
      activityAduitStatus: 0,
      activityStatus: 0,
      actHostUser: 0,
      startActTime: 0,
      endActTime: 0,
      isSignUp: false,
      isBlock: false,
      payPoint: 0,
      province: "",
      city: "",
      district: "",
      address: "",
      desc: '',
      activityType: '',
    });
    let dataHelpUserMessage = ref([
      {
        id: "",
        headUrl: "",
        userName: "",
        isSignUp: false,
        messageTime: "",
        content: "",
        postReply: {
          headUrl: "",
          userName: "",
          messageTime: "",
          content: "",
        },
      },
    ]);
    let pageNum = 1;
    let isNoMoreMessage = ref(false);
    let commentPlaceholder = "我来说两句..";
    let helpActType = ref(0);
    let comment = ref({
      showPopup: false,
      placeholder: commentPlaceholder,
      id: "",
      value: "",
    });
    let commentForm = ref({
      userId: "",
      linkId: "",
      messageTime: 0,
      helpActType: 0,
      parentId: "",
      content: ""
    });
    const enroll = ref({
      showPopup: false,
      placeholder: "请输入您的留言",
      form: {
        userName: "",
        phone: "",
        activityId: "",
        enrollForm: "",

        babyName: "",
        babySex: "",
        babyAge: "",
        community: "",

      },
    });
    const freeBack = ref({
      showPopup: false,
      placeholder: "请输入反馈信息",
      form: {
        id: "",
        feedback: "",
      },
    });
    watch(
      () => props.id,
      () => {
        reset();
        loadData();
      }
    );
    const reset = () => {
      pageNum = 1;
      isNoMoreMessage.value = false;
    };

    const loadData = () => {

      methods.getActivity();

    };
    //方法
    const methods = {
      img(key: string) {
        return fileBaseUrl + key;
      },

      async submitActSignUp() {

        let mobile = /^1[0-9][0-9]\d{8}$/;
        let errorMessage = "";
        if (enroll.value.form.userName.trim().length == 0) {
          errorMessage = "请输入家长姓名";
        }
        if (!mobile.test(enroll.value.form.phone)) {
          errorMessage = "请填写正确的手机号码";
        }
        if (enroll.value.form.community.trim().length == 0) {
          errorMessage = "请输入所在社区";
        }
        if (errorMessage != "") {
          toast.fail(errorMessage);
          return;
        }
        enroll.value.form.activityId = data.value.id;

        enroll.value.form.enrollForm = JSON.stringify({
          userName: enroll.value.form.userName.trim(),
          phone: enroll.value.form.phone.trim(),
          babyName: enroll.value.form.babyName.trim(),
          babySex: enroll.value.form.babySex.trim(),
          babyAge: enroll.value.form.babyAge.trim(),
          community: enroll.value.form.community.trim(),
        });


        var isokActSignUp = await postSignUp(enroll.value.form);
        if (isokActSignUp) {
          toast.success(`报名成功`);
          enroll.value.showPopup = false;
          this.loadData();

        } else {
          toast.fail('报名失败');
        }

      },
      async submitSignUp() {
        this.$dialog
          .confirm({
            title: "温馨提示：",
            message: "报名成功后，请准时参与活动。如未按时出席，将予以限制报名。",
          })
          .then(async () => {
            // on confirm
            enroll.value.showPopup = true;
          })
          .catch(() => {
            // on cancel
          });
      },


      async submitCancelSignUp() {

        var cancel = await postCancel({ activityId: data.value.id });
        if (cancel) {
          toast.success(`取消报名成功`);

          this.loadData();

        } else {
          toast.fail('取消报名失败');
        }
      },
      format(time: string | number | Date, string: string) {
        return new Date(time).format(string);
      },
      async getActivity() {
        const response: any = (await getActivityDetail(props.id as string)) || { rows: [], };
        data.value = response;
        methods.setWxShare();
      },

      formatImgUrl() {
        const headUrl = data.value.headUrl;
        if (headUrl) {
          return fileBaseUrl + headUrl;
        }
        const tenantInfo = getTenanCnf();
        return tenantInfo.logoSrc;
      },

      // 设置微信分享
      async setWxShare() {
        // const runEvnData = runEvn();
        const _titleInfo = data.value.title;
        // const imgUrl = this.img(this.imgs[0]);
        const shareData = {
          title: `${_titleInfo}`,
          desc: `${data.value.desc ||  data.value.activityType}`,
          link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: methods.formatImgUrl(), // 分享图标
        };
        await updateShareData(shareData);
      },
    };

    return {
      loadData, data, dataHelpUserMessage, enroll, freeBack,
      ...methods, helpActType, comment, isNoMoreMessage
    };
  },
  data() {
    return {
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {

  },
  props: {
    id: {
      type: String,
    },
  },
});

